export default {
  name: 'transaction_customer_address_postal_code',
  component_path: 'modules/procedures/blocks/BlockInputText',
  static_options: {
    autocomplete: 'shipping postal-code'
  }
}